import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { ChatInternalService } from '../../../services/chat-internal.service';
import { M_ChatInternalConversation } from '../../../models/M_ChatInternal';

@Component({
  selector: 'app-chat-internal-sidebar',
  templateUrl: './chat-internal-sidebar.component.html',
  styleUrls: ['./chat-internal-sidebar.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatIconButton],
})
export class ChatInternalSidebarComponent implements OnInit {
  @Input() selectedConversationId: number | null = null;
  @Output() selectConversation = new EventEmitter<number>();
  @Output() newConversation = new EventEmitter<void>();

  conversations: M_ChatInternalConversation[] = [];
  editingConversationId: number | null = null;
  editingTitle = '';

  private chatService = inject(ChatInternalService);

  ngOnInit(): void {
    this.loadConversations();
  }

  loadConversations(): void {
    this.chatService.getConversations().subscribe({
      next: (r) => {
        this.conversations = r.data;
        if (this.conversations.length > 0 && !this.selectedConversationId) {
          this.onSelect(this.conversations[0].id);
        }
      },
    });
  }

  refreshConversations(): void {
    this.loadConversations();
  }

  onSelect(id: number): void {
    this.selectConversation.emit(id);
  }

  onNew(): void {
    this.chatService.createConversation().subscribe({
      next: (r) => {
        this.conversations.unshift(r.data);
        this.selectConversation.emit(r.data.id);
      },
    });
  }

  onRename(conv: M_ChatInternalConversation, event: Event): void {
    event.stopPropagation();
    this.editingConversationId = conv.id;
    this.editingTitle = conv.title;
  }

  saveRename(conv: M_ChatInternalConversation): void {
    const newTitle = this.editingTitle.trim();
    if (!newTitle || newTitle === conv.title) {
      this.cancelRename();
      return;
    }

    this.chatService.updateConversation(conv.id, newTitle).subscribe({
      next: (r) => {
        conv.title = r.data.title;
        this.cancelRename();
      },
      error: () => {
        this.cancelRename();
      },
    });
  }

  cancelRename(): void {
    this.editingConversationId = null;
    this.editingTitle = '';
  }

  onRenameKeyDown(conv: M_ChatInternalConversation, event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.saveRename(conv);
    } else if (event.key === 'Escape') {
      this.cancelRename();
    }
  }
}
